export const JobStatus = {
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  NO_ACTIVE_JOB: 'NO_ACTIVE_JOB',
} as const;

export type JobStatusType = typeof JobStatus[keyof typeof JobStatus];

export interface JobInitiatedBy {
  userId: string;
  userName: string;
  userEmail: string;
}

export interface FailedStore {
  storeCode: number;
  error: string;
}

export interface JobProgressResponseDto {
  status: JobStatusType;
  message?: string;
  jobId?: string;
  initiatedBy?: JobInitiatedBy;
  totalStores?: number;
  processedStores?: number;
  successCount?: number;
  failedCount?: number;
  failedStores?: FailedStore[];
  percentComplete?: number;
  startTime?: string;
  lastUpdate?: string;
  estimatedTimeRemaining?: string;
  conciliationDate?: string; 
}
